import PaginationCount from "./src/PaginationCount.vue";

BX.namespace("BX.Citrus.Vue.Component");

BX.Citrus.Vue.Component.PaginationCount = function (props) {
	new CitrusUi.Vue({
		name: "PaginationCount",
		render: h => h(PaginationCount, {
			props: props
		}),
	}).$mount("#" + (props && props.hasOwnProperty('templateId') ? props.templateId : "app"));
}

